var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({ref:"label",tag:"component",class:{ 'label': _vm.tag == 'label' },attrs:{"contenteditable":_vm.editable},on:{"input":function($event){return _vm.update()}}},'component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }